import { createContext, FC, PropsWithChildren, useContext, useMemo } from 'react';

import { Link } from '@src/main/modules/common/link/domain/Link';
import { LinkRepository } from '@src/main/modules/common/link/domain/LinkRepository';
import { useLinkUseCases } from '@src/main/ui/providers/link/hooks/useLinkUseCase';

interface ContextState {
  link: string | undefined;
  updateLink: (link: Link) => void;
}

const LinkContext = createContext<ContextState>({} as ContextState);

interface Props {
  linkRepository: LinkRepository;
}

export const LinkContextProvider: FC<PropsWithChildren<Props>> = ({ children, linkRepository }) => {
  const { link, updateLink } = useLinkUseCases(linkRepository);

  const extractedLink = link?.link;

  const values = useMemo(
    () => ({
      link: extractedLink,
      updateLink,
    }),
    [extractedLink, updateLink],
  );

  return <LinkContext.Provider value={values}>{children}</LinkContext.Provider>;
};

export const useLinkContext = (): ContextState => useContext(LinkContext);
